<header class="site-header sticky-top">
  <div class="container container-max">
    <a [routerLink]="'/'" class="site-logo"><img src="/assets/img/logo.png" /></a>

    @if (utility.isMobile) {
      <button (click)="showMobileMenu.set(!showMobileMenu())" class="btn text-primary p-2 border-0" style="min-height: auto;">
        <iconify [name]="'lucide:menu'" [size]="30" />
      </button>

      @if (showMobileMenu()) { <div class="mobile-menu-items"> <ng-container [ngTemplateOutlet]="nav_menu" /></div> }

    } @else {
      <ng-container [ngTemplateOutlet]="nav_menu" />
    }
  </div>
</header>


<ng-template #nav_menu>
  <ul class="nav-list">
    <li><a class="nav-link" [routerLink]="''" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{exact: true}">Home</a></li>
    <li><a class="nav-link" [routerLink]="'/about'" [routerLinkActive]="'active'">About</a></li>
<!--    <li><a class="nav-link" [routerLink]="'/search'" [routerLinkActive]="'active'">Search</a></li>-->
    <li><a class="nav-link" [routerLink]="'/standards'" [routerLinkActive]="'active'">Standards</a></li>
    <li><a class="nav-link" [routerLink]="'/faq'" [routerLinkActive]="'active'">FAQ</a></li>
    <li><a class="nav-link" [routerLink]="'/report-psc'" [routerLinkActive]="'active'">Report</a></li>
    <li><a class="nav-link" [routerLink]="'/contact'" [routerLinkActive]="'active'">Contact</a></li>
  </ul>

  <div class="cta-wrapper">
    <button class="btn search-btn border-0" [routerLinkActive]="'active'" [routerLink]="'/search'">
      <iconify [name]="'lucide:search'" [classNames]="'fs-18'" />
      Search Registry
    </button>
    <!--<button class="btn btn-outline-primary" [routerLink]="'/auth'">Portal Login</button>-->
    <!--<button class="btn btn-success">Register</button>-->
  </div>
</ng-template>
